// Is Dagilimlari sayfasi icin sorgular.
//
// Yaklasim: her entity (ekip veya kisi) icin ayri hafif bir jobs sorgusu
// atmak yerine, TEK bir jobs sorgusu ile ilgili tum entity'lerin isslerini
// cek → client'ta grupla. Hasura tarafi zaten multi-tenant WHERE'i uygular.
//
// Alan seti minimal: job_type_rel.name (yeni FK), job_type (legacy text),
// job_status. Kimin isi oldugu icin job_assignments.technical_user_id /
// financial_user_id de dahil (kisi bazli grupabilme icin).

export const GET_TEAMS_LITE_FOR_DISTRIBUTION = `
  query GetTeamsLiteForDistribution($companyId: Int!) {
    teams(
      where: { company_id: { _eq: $companyId } }
      order_by: { name: asc }
    ) {
      id
      name
      users_aggregate { aggregate { count } }
    }
  }
`;

export const GET_TEAM_USERS_LITE = `
  query GetTeamUsersLite($teamId: Int!) {
    users(
      where: { team_id: { _eq: $teamId } }
      order_by: { first_name: asc }
    ) {
      id
      first_name
      last_name
      work_end_date
    }
  }
`;

export const GET_USERS_LITE_FOR_DISTRIBUTION = `
  query GetUsersLiteForDistribution($companyId: Int!) {
    users(
      where: { company_id: { _eq: $companyId } }
      order_by: [{ first_name: asc }, { last_name: asc }]
    ) {
      id
      first_name
      last_name
      team_id
      team { id name }
    }
  }
`;

// Ana dagilim sorgusu — bir kullanici kumesinin (ekiplere veya kisilere
// gore turetilir) uzerinden gecen tum aktif is'lerin sadece dagilim icin
// gereken alanlarini doner. Uygulayici tarafi client-side gruplar.
//
// `activeOnly`: true ise HIDDEN_STATUS'lardaki isler (TAMAMLANDI, KAPATILDI,
// DANISMANLIK_SONLANDIRILDI, REDDEDILDI, ORTAK_BULUNDU) DAHIL EDILMEZ. Bu,
// dashboard kartlariyla ayni davranis.
//
// `includeYazim`: false ise YAZIMDA statusundeki isler de haric tutulur;
// "yazimdaki isleri de goster" toggle'i icin.
// jobs → job_assignment TEKIL object relationship (FK: jobs.job_assignment_id).
// Bir isin tek bir atama satiri var; ekip veya kisi bilgisi burada tutulur.
// team_id ve user_id ayni satirda birlikte veya birbirinden bagimsiz olabilir.
export const GET_JOBS_FOR_DISTRIBUTION = `
  query GetJobsForDistribution($where: jobs_bool_exp!) {
    jobs(where: $where) {
      id
      job_type
      job_type_rel { id name }
      job_status
      job_assignment {
        id
        technical_user_id
        financial_user_id
        technical_team_id
        financial_team_id
        technical_user { id team_id }
        financial_user  { id team_id }
      }
    }
  }
`;
